import React, { useEffect, useState } from 'react';
import Preloader from '../Components/Preloader';
import { NavLink } from 'react-router-dom';
import Error_Seo from '../SEO/Error_Seo';

function Error() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);
    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Error_Seo />
                    {/* Start 404 Error page */}
                    <div className="error-area ptb-150">
                        <div className="container">
                            <div className="error-content-wrap">
                                <img className="error-image" src="assets/images/error-image.png" alt="image" />
                                <p className="text-black">We'r sorry, the page you requested could not be found Please go back to the homepage</p>
                                <NavLink to="/" className="default-btn">Go To Homepage</NavLink>
                            </div>
                        </div>
                    </div>
                    {/* End 404 Error page */}

                </>
            )}
        </div>
    );
}

export default Error
